export class CONSTANT_MESSAGES {
    public static ADD_FACILITY_SUCCESS = 'Added a Activity successfully.';
    public static ADD_FACILITY_ERROR = 'An error occured while adding the Activity.';
    public static FORGOT_PASSWORD_ERROR = 'An error occured in forgot password.';
    public static ERROR_IN_FACILITY_START_TIME_AND_END_TIME = 'Activity start time should be less than end time. Please try again.';
    public static ERROR_IN_FACILITY_TIME_DURATION = 'Activity start time should not be the same as end time. Please try again.';
    public static ERROR_IN_FACILITY_CLOSED_TIME_SLOT = 'Ensure Activity closure time is within Activity open timing.';
    public static ERROR_IN_FACILITY_CLOSED_START_TIME_AND_END_TIME =
    'Ensure Activity closure start time should be less than end time.';
    public static ERROR_IN_FACILITY_CLOSED_TIME_DURATION = 'Ensure Activity closure start and end times should not be same.';
    public static ERROR_IN_FACILITY_PEAK_TIME_SLOT = 'Ensure Activity peak time is within Activity open timings.';
    public static ERROR_IN_FACILITY_PEAK_START_TIME_AND_END_TIME = 'Ensure Activity peak start time should be less than end time.';
    public static ERROR_IN_FACILITY_PEAK_TIME_DURATION = 'Ensure Activity peak start and end times not the same.';
    public static ERROR_IN_FACILITY_PEAK_TIME_AND_CLOSED_TIME = 'Ensure Activity peak time and closure time should not same.';
    public static REQUIRE_EMAIL_ID = 'Please enter email id.';
    public static REQUIRE_CONTACT_NUMBER = 'Please enter Contact Number.';
    public static REQUIRE_MEMBERSHIP_ID = 'Please enter Membership Id.';
    public static REQUIRE_VALID_EMAIL_ID = 'Please enter a valid Email Id.';
    public static REQUIRE_VENDOR = 'Vendor is required.';
    public static REQUIRE_MEMBER_OBJECT = 'Member object is null.';
    public static DELETE_CONFIRMATION = 'Are you sure you want to delete this Activity?';
    public static EDIT_CONFIRMATION = 'Your data will be lost. Do you want to continue?';
    public static LOGOUT_CONFIRMATION = 'Are you sure you want to Logout?';
    public static ERROR_IN_BOOKING_UNIT = 'Booking slot should not greater than open hours';
    public static REDIRECT_FROM_ACTIVITY = 'Your data will be loss, do you want to continue';
    public static MESSAGE_NO_ACTIVITY_ADDED = 'Currently, there are no Activities added. Please add an Activity.';

    // BOOKINGENTRY
    public static CANCEL_BOOKING = 'Are you sure, you want to cancel this booking ?';
    public static MAKE_PAYMENT = 'Are you sure, you want to make a payment ?';
    public static DATA_MATCH = 'Data mismatch.'
    // FEEDBACK
    public static MESSAGE_NO_FEEDBACK_ADDED = 'Currently, there are no feedback added.';
    // Group
    public static DEACTIVATE_GROUP = 'Do you want to deactivate the group?';
    public static ACTIVATE_GROUP = 'Do you want to activate the group?';
    public static NO_MEMBER_ADDED = 'Currently, there are no members in this group. Please add members';
    public static NO_RECORD_FOUND = 'No records found.';
    public static REMOVE_MEMBERS = 'please select member to remove from group';
    public static CONFIRMATION_REMOVE_MEMBER = 'Are you sure to remove member from group';
    public static ADD_MEMBER = 'Please select member to add in group';
    public static CONFIRMATION_ADD_MEMBER = 'Are you sure to add member in group';
    public static NO_GROUP = 'Currently, there are no groups added. Please add a group.';
    public static CONFIRMATION_DELETE_GROUP_PART1 = 'Are you sure to delete';
    public static CONFIRMATION_DELETE_GROUP_PART2 = 'group ?';
    public static CONFIRMATION_CREATE_GROUP = 'Are you sure, you want create group';
    // CREATE NO_GROUP
    public static ADD_MEMBER_GROUP = 'Add Members in group';
    public static GENDER_LIST = ['Male', 'Female', 'Other'];
    public static FILTER_MEMBER = ['Group', 'Preferences', 'Inactive', 'Disable For Activity', 'Payment Pending'];
    public static ATTENDEES_MEMBER_AT_BOOKING = 1;
    // deactivate members
    public static DEACTIVATE_MEMBERS = 'It will be deactivate untill not activate.';
    public static DATE_CONFIRMATION = 'End date should be greater than start date.';
    // booking calendar
    public static DAY_BOOKING_ERROR = 'Please ensure that the booking is made for a day!';
    public static NUMPER_OF_PEOPLE_ERROR = 'Please enter valid number of people';
    // feeds
    public static SELECT_MEMBER_FEED = 'Please select members for broadcast';
    public static SELECT_Group_FEED = 'Please select groups for broadcast';
    public static IMAGE_ERROR = 'Please select a valid image format (.jpg, .png, .bmp, .jpeg, .tiff)';
    public static ERROR_MESSAGE_SUBJECT = 'Please fill Subject';
    public static ERROR_MESSAGE_CONTENT = 'Please fill Content';
    public static SELECT_ACTIVITY_FOR_ALERT = 'Please select activity';
    public static SELECT_RECIPIENTS_BROADCAST = 'Please fill Recipients';
    public static NO_FEED_ADDED_MESSAGE = 'Currently, there are no feeds added.';
    public static NO_MEMBER_AVAILABLE = 'There is no member available';
    public static NO_GROUP_AVAILABLE = 'There is no group available';
    public static INVALID_URL = 'Enter proper url and there should only one url'

    // member detail
    public static DELETE_MEMBER = 'Are you sure you want to delete this member?';
    public static RESEND_CODE_MEMBER = 'Are you sure you want to resend the code?';
    public static DEACTIVATE_MEMBER = 'Are you sure you want to deactivate this member?';
    public static ACTIVATE_MEMBER = 'Are you sure you want to activate this member?';
    public static DESABLE_MEMBER = 'Please select the members that you want to disable.';
    public static ENABLE_MEMBER = 'Please select the members that you want to enable.';
    public static DEATCIVATE_MULTIPLE_MEMBER = 'Are you sure you want to deactivate these members?'
    public static SELECT_DEATCIVATE_MEMBER = 'Please select the members that you want to deactivate.'

    // member

    public static NO_MEMBER_ADDED_MESSAGE = 'Currently, there are no members added. Please add a member.';
    public static FILE_NOT_SUPPORT = 'File not supported.'
    // INACTIVATE MEMBER
    public static SELECT_MEMBER_TO_ACTIVATE = 'Select members to activate.';

    //upload member on-boarding
    public static INVALID_FILE_COLUMNS = 'Please verify the columns in the file you have uploaded.'
    public static SKIP_WIZARD = 'Are you sure you want to skip the wizard process';
    public static FINISH_WIZARD = 'Wizard process completed succesfully. You will now be taken to the all members screen.';
    public static REMARK_MEMBER = 'Member added successfully.'
    public static SERVICE_ERROR_INVITE_MEMBER = 'Something Went Wrong. Service returned error'
    constructor() { }
}


// WEBPACK FOOTER //
// ./src/app/constants/constants-messages.ts